import styled from 'styled-components';

import { DateRangePicker } from 'ui/components/DatePicker';

export const RangePicker = styled(DateRangePicker)`
  border-radius: 6px;

  & {
    min-width: auto;
  }

  & .ant-picker-input > input {
    font-size: 12px;
    height: 22px;
  }
`;
